/*
 * Object.groupBy is ES2024. create-react-app neither transpiles nor polyfills
 * it, so on Safari before 17.4 and older Chrome and Firefox it is simply
 * undefined — and the care plan and Education screens threw on open rather
 * than rendering anything.
 *
 * Same contract as Object.groupBy: keys are the callback's result run through
 * String(), values are arrays in the order encountered, and the returned
 * object has no prototype (so a group called "constructor" is just a group).
 */
export function groupBy(items, keyOf) {
  const groups = Object.create(null);
  let index = 0;
  for (const item of items || []) {
    const key = String(keyOf(item, index++));
    if (!groups[key]) groups[key] = [];
    groups[key].push(item);
  }
  return groups;
}
